import { styled, TableBody, TableCell, tableCellClasses } from '@mui/material'
import CommissionTableRow from '../commission-table-row/commission-table-row'
import { CommissionResponse } from 'store/commissions/commissions.types'

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))

interface CommissionTableBodyProps {
  commissions: CommissionResponse[]
}

const CommissionTableBody = ({ commissions }: CommissionTableBodyProps) => {
  return (
    <TableBody>
      {commissions.map((commission) => (
        <CommissionTableRow key={commission.invoiceId} commission={commission} />
      ))}
    </TableBody>
  )
}

export default CommissionTableBody

